import { render, staticRenderFns } from "./EditBotBuyLowForm.vue?vue&type=template&id=05e255d4&"
import script from "./EditBotBuyLowForm.vue?vue&type=script&lang=js&"
export * from "./EditBotBuyLowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports